import {
  Card,
  CardContent,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Typography,
} from '@growdash/design-system/atoms';
import GrowintelImage from '@growdash/growintel/components/atoms/growintel-image';
import { MenuItem } from '@growdash/growintel/generated';
import useCurrency from '@growdash/growintel/hooks/useCurrency';

export default function MenuItemCard(item: MenuItem) {
  const currency = useCurrency();
  const { item_name, item_image, item_price, item_description } = item;
  return (
    <TooltipProvider>
      <Card className="overflow-hidden transition-all relative">
        <CardContent className="p-3">
          <div className="flex gap-2">
            <GrowintelImage
              src={item_image ?? ''}
              className="h-24 w-24 border border-secondary rounded-xl"
            />

            <div className="flex-1 flex flex-col items-start justify-between">
              <div>
                <h3 className="font-medium text-base leading-none">
                  {item_name}
                </h3>
              </div>
              <Tooltip delayDuration={0}>
                <TooltipTrigger hidden={!item_description?.length} asChild>
                  <Typography className="text-sm text-quarternary my-1 line-clamp-2">
                    {item_description}
                  </Typography>
                </TooltipTrigger>
                <TooltipContent hidden={!item_description?.length}>
                  <div className="max-w-[300px] text-sm">
                    {item_description}
                  </div>
                </TooltipContent>
              </Tooltip>
              <div className="ml-auto mt-auto">
                <p className="font-semibold ml-auto">
                  {item_price.toFixed(2)} {currency}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </TooltipProvider>
  );
}
